module.exports = __webpack_public_path__ + "img/OurServiceFixed_pic2.c1b37a85.png";